<app-page-bar></app-page-bar>

<app-page>
  <div class="page-header">
    <h2>{{title}}</h2>

    <button mat-stroked-button
            *ngIf="canPoll$ | async"
            [disabled]="polling"
            (click)="pollResponses()">
      <mat-icon>sync</mat-icon>
      Poll bank responses
    </button>
  </div>

  <section>

    <div class="filter-bar">
      <mat-chip-list multiple selectable
                     class="status-chips"
                     aria-label="Filter by payment status">
        <mat-chip *ngFor="let s of statuses"
                  color="primary"
                  [selected]="q.status.includes(s.value)"
                  (click)="toggleStatus(s.value)"
                  (selectionChange)="onChipSelectionChange(s.value, $event)">
          <mat-icon *ngIf="q.status.includes(s.value)" class="chip-check">check</mat-icon>
          {{ s.label }}
        </mat-chip>
      </mat-chip-list>

      <button mat-stroked-button (click)="reset()">Clear</button>
    </div>

    <div class="table-container mat-elevation-z8">
      <mat-table #table [dataSource]="dataSource">

        <ng-container matColumnDef="created_at">
          <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.created_at | date:'short'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="invoice_id">
          <mat-header-cell *matHeaderCellDef>Invoice</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.invoice_id}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="amount.amount">
          <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.amount?.amount | currency:'EUR'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="to_name">
          <mat-header-cell *matHeaderCellDef>Receiver</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.to_name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="channel">
          <mat-header-cell *matHeaderCellDef>Channel</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.is_legacy ? element.legacy_payment_channel : element.provider_key }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.status}}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;"
                 matRipple
                 [routerLink]="['/invoices', row.invoice_id]"
                 [class.status-success]="row.status === 'SUCCESS'"
                 [class.status-failed]="row.status === 'FAILED'">
        </mat-row>

      </mat-table>
    </div>
  </section>
</app-page>
